import React from "react";
import Hero from "@/components/Hero";
import BookingSection from "@/components/BookingSection";
import SchedulesSection from "@/components/SchedulesSection";
import AnnouncementsSection from "@/components/AnnouncementsSection";
import ProgramsSection from "@/components/ProgramsSection";
import TeachersSection from "@/components/TeachersSection";
import GallerySection from "@/components/GallerySection";
import AchievementsSection from "@/components/AchievementsSection";
import NewsSection from "@/components/NewsSection";
import ReadingChallengeSection from "@/components/ReadingChallengeSection";
import ContactSection from "@/components/ContactSection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <BookingSection />
      <SchedulesSection />
      <AnnouncementsSection />
      <ProgramsSection />
      <TeachersSection />
      <GallerySection />
      <AchievementsSection />
      <NewsSection />
      <ReadingChallengeSection />
      <ContactSection />
    </main>
  );
}
